import { NgModule } from "@angular/core";
import { DynamicLabelComponent } from './dynamic-label.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material.module';
import { LabelDesignComponent } from './label-design/label-design.component';
import { LabelFormComponent } from './label-form/label-form.component';
import { LabelResultComponent } from './label-result/label-result.component';
import { AbwConditionalFormatingModule } from '../@core/abw-conditional-text-formating.module';

@NgModule({
    declarations: [
        LabelDesignComponent, LabelFormComponent, LabelResultComponent, DynamicLabelComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule,
        AbwConditionalFormatingModule
    ],
    entryComponents: [
        DynamicLabelComponent
    ]
})
export class LabelModule {}